import type { KgInsight } from '@api/api/kg-insights';
import { KgInsightPreview } from '@terminal/widgets/catalyst-insights-drawer/catalyst-widget/components/kg-insight-content/KgInsightPreview';
import { RefCallback } from 'react';

import { isKgInsightSectionVisible } from '../../utils/kg-insight-utils';
import { KgInsightSection } from '../kg-insight-section/KgInsightSection';
import { KgInsightSectionRenderer } from '../kg-insight-section-renderer/KgInsightSectionRenderer';

type KgInsightArticleProps = {
  kgInsight: KgInsight;
  setSectionRef: (id: string) => RefCallback<HTMLElement>;
};

export const KgInsightArticle = ({
  kgInsight,
  setSectionRef,
}: KgInsightArticleProps) => (
  <>
    <KgInsightSection ref={setSectionRef('hero')}>
      <KgInsightPreview kgInsight={kgInsight} />
    </KgInsightSection>

    {kgInsight.sections.filter(isKgInsightSectionVisible).map(section => (
      <KgInsightSectionRenderer
        key={section.type}
        section={section}
        kgInsight={kgInsight}
        setSectionRef={setSectionRef}
      />
    ))}
  </>
);
